import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { CACHE_PROVINCE } from "src/constants/actionCache";
import { useState } from "react";
import ProvincePopup from "../Popup/ProvincePopup";
import ShowCachePRovince from "../ShowCache/ShowCacheProvince";

const ProvinceControlPanel = ({
  currentActionCache,
  openPopup,
  setOpenPopup,
  recordForEdit,
  addOrEdit,
  handleOpenPopup,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        margin: "20px 0 10px 0",
      }}
    >
      <DeployCache
        title="Cache Province"
        isShowButton={isShowCache(currentActionCache, CACHE_PROVINCE)}
      >
        <ShowCachePRovince
          disableButton={disableButton}
          setDisableButton={setDisableButton}
        />
      </DeployCache>

      <ProvincePopup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        handleOpenPopup={handleOpenPopup}
      />
    </div>
  );
};

export default ProvinceControlPanel;
